/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MLDialog from '../../MLDialog/MLDialog';
import Spinner from '../../LazyWidgets/Spinner';
import { regex } from '../../../utils/util';
import { getConfigObject } from '../../../utils/config';
import LinkCourses from './LinkCourses/LinkCourses';
import LinkAccount from './LinkAccount/LinkAccount';
import CreateNewCourseSuccess from './CreateNewCourseSuccess/CreateNewCourseSuccess';
import {
  getCreateCourse,
  getReefCourseList,
  linkReefCourse,
  linkReefInstructorAccount,
  linkReefStudentAccount,
} from '../../../actions/reef';

import s from './LinkReefDialog.module.css';
import { syncIClicker } from '../../../actions/analyticsEvents';
import { sendAnalyticsEvent } from '../../../actions/sendAnalytics';
import iClickerLogoUrl from '../images/white-iclicker-student-logo.svg';

const ICLICKER_COURSE_CREATION_CANCELLED = 'none';

export class LinkReefDialog extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    // eslint-disable-next-line react/no-unused-prop-types
    show: PropTypes.bool,
    dispatch: PropTypes.func,
    handleAlertReef: PropTypes.func,
    userIsInstructor: PropTypes.bool,
    userIsStudent: PropTypes.bool,
    isUserReefLinked: PropTypes.bool,
    hasInstructorLinkedCourse: PropTypes.bool,
    courseId: PropTypes.string,
    disableEnforceFocus: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      courseList: null,
      selectedCourse: null,
      errorMessage: '',
      createUrl: null,
      showCreateCourseIFrame: false,
      createCourseIFrameLoaded: false,
      showCloseScreen: false,
      showModal: true,
      iClickerCourseId: null,
      hasLinked: false,
    };
    window.Gradebook = window.Gradebook || {};
    const self = this;
    window.Gradebook.closeIClickerCreateScreen = function (iClickerCourseId) {
      self.handleAutoCourseAssociation({ iClickerCourseId });
    };
  }

  componentDidMount() {
    const {
      hasInstructorLinkedCourse,
      userIsInstructor,
      isUserReefLinked,
      dispatch,
      courseId,
    } = this.props;
    if (isUserReefLinked && !hasInstructorLinkedCourse && userIsInstructor) {
      this.callGetReefCourseList(dispatch, courseId);
      this.loadIframe();
    }
  }

  async callGetReefCourseList(dispatch, courseId) {
    const data = await dispatch(getReefCourseList(courseId));
    if (!data.courses) return;
    this.setState({ courseList: data.courses });
  }

  loadIframe() {
    const {
      hasInstructorLinkedCourse,
      courseId,
      userIsInstructor,
      isUserReefLinked,
      dispatch,
    } = this.props;
    const { createCourseIFrameLoaded } = this.state;
    if (
      isUserReefLinked &&
      !hasInstructorLinkedCourse &&
      userIsInstructor &&
      !createCourseIFrameLoaded
    ) {
      this.startIFrameLoading(dispatch, courseId);
    }
  }

  commonWarningHandler(err, defaultMessage) {
    const warning = {
      type: 'warning',
      message: err.message || defaultMessage,
    };
    if (this.props.handleAlertReef) {
      this.props.handleAlertReef(warning);
    }
  }

  startIFrameLoading(dispatch, courseId) {
    this.redirectInterval = window.setInterval(() => {
      const { createCourseIFrameLoaded } = this.state;
      if (createCourseIFrameLoaded) {
        window.clearInterval(this.redirectInterval);
      } else {
        dispatch(getCreateCourse(courseId)).then((redirectUrl) => {
          this.handleRedirect(redirectUrl);
        });
      }
    }, 5000);
  }

  handleRedirect(redirectUrl) {
    if (redirectUrl) {
      window.clearInterval(this.redirectInterval);
      this.setState({
        loadIFrame: true,
        createUrl: redirectUrl,
      });
    }
  }

  handleLinkReef = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    const {
      userIsInstructor,
      userIsStudent,
      dispatch,
      handleAlertReef,
      courseId,
      onClose,
    } = this.props;
    const info = { email, password };

    try {
      if (userIsInstructor) {
        await dispatch(linkReefInstructorAccount(courseId, info));
        this.startIFrameLoading(dispatch, courseId);
        const data = await dispatch(getReefCourseList(courseId));
        if (data.courses) this.setState({ courseList: data.courses });
      } else if (userIsStudent) {
        await dispatch(linkReefStudentAccount(courseId, info));
        handleAlertReef({
          type: 'success',
          message: 'iClicker Account Linked',
        });
        onClose();
      }
    } catch (err) {
      this.commonWarningHandler(err, 'iClicker Login failed');
    }
  };

  handleCreateCourse = () => {
    this.setState({
      showCreateCourseIFrame: true,
    });
  };

  handleAutoCourseAssociation = async ({ iClickerCourseId }) => {
    const { courseId, dispatch } = this.props;
    if (!iClickerCourseId) return;

    // If the iClickerCourseId is 'none', that means the user
    // canceled the creation of the course within the iClicker
    // iframe and we should revert our modal to the course list
    if (iClickerCourseId === ICLICKER_COURSE_CREATION_CANCELLED) {
      this.setState({
        showCreateCourseIFrame: false,
        showCloseScreen: false,
        hasLinked: false,
      });
      return;
    }

    try {
      await dispatch(
        linkReefCourse(courseId, { reefCourseId: iClickerCourseId }),
      );
      this.setState({
        showCreateCourseIFrame: false,
        showCloseScreen: true,
        hasLinked: true,
      });
    } catch (err) {
      this.commonWarningHandler(err, 'iClicker Course Association failed');
    }
  };

  handleCourseAssociation = async () => {
    const { courseId, dispatch, handleAlertReef, onClose } = this.props;
    const { selectedCourse } = this.state;

    if (!selectedCourse) return;
    try {
      await dispatch(
        linkReefCourse(courseId, { reefCourseId: selectedCourse }),
      );
      handleAlertReef({
        type: 'success',
        message: 'iClicker Course Linked',
      });
      this.setState({ showModal: false });
      dispatch(sendAnalyticsEvent(syncIClicker(courseId)));
      onClose();
    } catch (err) {
      this.commonWarningHandler(err, 'iClicker Course Association failed');
      this.setState({ showModal: false });
    }
  };

  handleEmailChange = (e) => {
    const value = e.target.value;
    let errorMessage = '';
    if (!regex.email(value)) {
      errorMessage = 'Not a valid email address';
    }
    this.setState({
      email: value,
      errorMessage,
    });
  };

  handlePasswordChange = (e) => {
    const value = e.target.value;
    this.setState({ password: value });
  };

  /* TODO: RNI-3332 remove this function when the feature flag is removed */
  handleCourseSelectionChange = (_e, value) => {
    this.setState({ selectedCourse: value });
  };

  handleIFrameLoad = () => {
    this.setState({
      createCourseIFrameLoaded: true,
    });
  };

  render() {
    const {
      userIsStudent,
      userIsInstructor,
      onClose,
      isUserReefLinked,
      handleAlertReef,
      dispatch,
      courseId,
      disableEnforceFocus,
    } = this.props;
    const {
      createUrl,
      showCreateCourseIFrame,
      createCourseIFrameLoaded,
      showCloseScreen,
      showModal,
      hasLinked,
      courseList,
      selectedCourse,
      email,
      password,
      errorMessage,
    } = this.state;

    const {
      REEF_INSTRUCTOR_CREATE_ACCOUNT_LINK,
      REEF_STUDENT_CREATE_ACCOUNT_LINK,
      REEF_FORGOT_PASSWORD_LINK,
    } = getConfigObject();

    let modalWindowClass = userIsStudent ? s.modalStudentWindow : s.modalWindow;
    const createAccountLink = userIsInstructor
      ? REEF_INSTRUCTOR_CREATE_ACCOUNT_LINK
      : REEF_STUDENT_CREATE_ACCOUNT_LINK;

    window.scroll(0, 0);
    return (
      <MLDialog
        className={modalWindowClass}
        title="iClicker Sync"
        titleClassName={s.modalTitle}
        titleTextClassName={s.titleTextClassName}
        closeButtonClassName={s.closeButtonClassName}
        overlayClassName={s.overlayClassName}
        bodyClassName={s.modalBody}
        show={showModal}
        onClose={() => {
          window.clearInterval(this.redirectInterval);
          if (hasLinked) {
            const success = {
              type: 'success',
              message: 'iClicker Account Linked',
            };
            handleAlertReef(success);
          }
          onClose();
        }}
        disableEnforceFocus={disableEnforceFocus}
      >
        <div>
          {showCreateCourseIFrame && !createCourseIFrameLoaded && (
            <Spinner className={s.iClickerSpinner} />
          )}
          {userIsStudent && (
            <div className={s.imageStudentCont}>
              <img
                className={s.imageStudent}
                src={iClickerLogoUrl}
                alt="iClicker Logo"
              />
            </div>
          )}
          {!isUserReefLinked && (
            <LinkAccount
              email={email}
              userIsStudent={userIsStudent}
              createAccountLink={createAccountLink}
              errorMessage={errorMessage}
              password={password}
              userIsInstructor={userIsInstructor}
              forgotPasswordLink={REEF_FORGOT_PASSWORD_LINK}
              handleEmailChange={this.handleEmailChange}
              handlePasswordChange={this.handlePasswordChange}
              handleLinkReef={this.handleLinkReef}
            />
          )}
          {!showCreateCourseIFrame && !showCloseScreen && (
            <LinkCourses
              selectedCourse={selectedCourse}
              courseList={courseList}
              handleCreateCourse={this.handleCreateCourse}
              handleGetReefCourseList={() =>
                this.callGetReefCourseList(dispatch, courseId)
              }
              handleChangeButtonGroup={this.handleCourseSelectionChange}
              handleCourseAssociation={this.handleCourseAssociation}
            />
          )}
          {showCreateCourseIFrame && createUrl && (
            <iframe
              title="Create iClicker Course"
              className={s.iframe}
              onLoad={this.handleIFrameLoad}
              width={400}
              height={window.innerHeight * 0.6}
              src={createUrl}
              style={{
                display: showCreateCourseIFrame ? 'block' : 'none',
              }}
            />
          )}
          {showCloseScreen && (
            <CreateNewCourseSuccess modal={this} dispatch={dispatch} />
          )}
        </div>
      </MLDialog>
    );
  }
}
